import { render } from "./Lince.vue?vue&type=template&id=6830d3f6&scoped=true&ts=true"
import script from "./Lince.vue?vue&type=script&lang=ts"
export * from "./Lince.vue?vue&type=script&lang=ts"

import "./Lince.vue?vue&type=style&index=0&id=6830d3f6&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6830d3f6"]])

export default __exports__